import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import {
  addDoc,
  updateDoc,
  getDoc,
  doc,
  collection,
} from "firebase/firestore";
import { db } from "../firebase/firebase";

export default function AtendentesCreate({ isEditMode }) {
  const { id } = useParams();
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    password: "",
    role: "atendente",
    status: "offline"
  });
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (id || isEditMode) {
      loadOperator();
    }
  }, [id, isEditMode]);

  async function loadOperator() {
    setLoading(true);
    try {
      const operatorId = id || isEditMode;
      if (!operatorId) return;
      
      const snap = await getDoc(doc(db, "operators", operatorId));
      if (snap.exists()) {
        const data = snap.data();
        setFormData({
          name: data.name || "",
          email: data.email || "",
          password: "", // Não carrega senha por segurança
          role: data.role || "atendente",
          status: data.status || "offline"
        });
      } else {
        alert("Atendente não encontrado!");
        navigate("/operadores");
      }
    } catch (error) {
      console.error("Erro ao carregar atendente:", error);
      alert("Erro ao carregar dados do atendente.");
    } finally {
      setLoading(false);
    }
  }

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (saving) return;
    
    // Validação básica
    if (!formData.name || !formData.email) {
      alert("Nome e email são obrigatórios!");
      return;
    }

    const isNew = !id && !isEditMode;
    if (isNew && !formData.password) {
      alert("Senha é obrigatória para novo atendente!");
      return;
    }

    setSaving(true);
    
    try {
      const dadosParaSalvar = {
        name: formData.name.trim(),
        email: formData.email.trim(),
        role: formData.role,
        status: formData.status,
        updatedAt: new Date()
      };

      // Se for um novo atendente e tiver senha
      if (isNew && formData.password) {
        dadosParaSalvar.password = formData.password;
        dadosParaSalvar.createdAt = new Date();
      }

      const operatorId = id || (isEditMode ? isEditMode : null);
      
      if (operatorId) {
        await updateDoc(doc(db, "operators", operatorId), dadosParaSalvar);
        alert("Atendente atualizado com sucesso!");
      } else {
        await addDoc(collection(db, "operators"), dadosParaSalvar);
        alert("Atendente criado com sucesso!");
      }
      
      navigate("/operadores");
    } catch (error) {
      console.error("Erro ao salvar atendente:", error);
      alert("Erro ao salvar atendente. Tente novamente.");
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return (
      <div style={{
        textAlign: 'center',
        padding: '60px 20px',
        background: 'white',
        borderRadius: '12px'
      }}>
        <div style={{
          display: 'inline-block',
          width: '50px',
          height: '50px',
          border: '4px solid #f3f3f3',
          borderTop: '4px solid #e36a8d',
          borderRadius: '50%',
          animation: 'spin 1s linear infinite',
          marginBottom: '20px'
        }}></div>
        <p style={{ color: '#555' }}>Carregando dados do atendente...</p>
        
        <style>{`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}</style>
      </div>
    );
  }

  const isNew = !id && !isEditMode;

  return (
    <div style={{
      background: 'white',
      borderRadius: '12px',
      padding: '30px',
      boxShadow: '0 4px 15px rgba(0,0,0,0.05)'
    }}>
      <header style={{ marginBottom: '30px' }}>
        <h1 style={{
          fontSize: '32px',
          fontWeight: '800',
          color: '#e36a8d',
          marginBottom: '5px',
          paddingBottom: '15px',
          borderBottom: '2px solid #e9ecef'
        }}>
          {isNew ? 'Criar Atendente' : 'Editar Atendente'}
        </h1>
        <p style={{ color: '#555', fontSize: '15px' }}>
          {isNew 
            ? 'Adicione um novo atendente ao painel One Love para atendimento via IA do Amor.' 
            : 'Atualize as informações do atendente abaixo.'}
        </p>
      </header>

      <form onSubmit={handleSubmit}>
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
          gap: '20px',
          marginBottom: '30px'
        }}>
          {/* Nome */}
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <label htmlFor="name" style={{
              fontWeight: '600',
              marginBottom: '8px',
              color: '#333',
              fontSize: '14px'
            }}>
              Nome completo <span style={{ color: '#e36a8d' }}>*</span>
            </label>
            <input
              type="text"
              id="name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              placeholder="Ex. Ana Souza"
              required
              disabled={saving}
              style={{
                padding: '12px 15px',
                border: '1px solid #dee2e6',
                borderRadius: '8px',
                fontSize: '14px',
                transition: 'all 0.2s'
              }}
            />
          </div>

          {/* Email */}
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <label htmlFor="email" style={{
              fontWeight: '600',
              marginBottom: '8px',
              color: '#333',
              fontSize: '14px'
            }}>
              Email de acesso <span style={{ color: '#e36a8d' }}>*</span>
            </label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              placeholder="teste@onelove.com"
              required
              disabled={saving}
              style={{
                padding: '12px 15px',
                border: '1px solid #dee2e6',
                borderRadius: '8px',
                fontSize: '14px',
                transition: 'all 0.2s'
              }}
            />
          </div>

          {/* Senha (apenas para criação) */}
          {isNew && (
            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <label htmlFor="password" style={{
                fontWeight: '600',
                marginBottom: '8px',
                color: '#333',
                fontSize: '14px'
              }}>
                Senha provisória <span style={{ color: '#e36a8d' }}>*</span>
              </label>
              <input
                type="password"
                id="password"
                name="password"
                value={formData.password}
                onChange={handleChange}
                placeholder="Digite uma senha"
                required={isNew}
                disabled={saving}
                style={{
                  padding: '12px 15px',
                  border: '1px solid #dee2e6',
                  borderRadius: '8px',
                  fontSize: '14px',
                  transition: 'all 0.2s'
                }}
              />
            </div>
          )}

          {/* Cargo */}
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <label htmlFor="role" style={{
              fontWeight: '600',
              marginBottom: '8px',
              color: '#333',
              fontSize: '14px'
            }}>
              Cargo
            </label>
            <select
              id="role"
              name="role"
              value={formData.role}
              onChange={handleChange}
              disabled={saving}
              style={{
                padding: '12px 15px',
                border: '1px solid #dee2e6',
                borderRadius: '8px',
                fontSize: '14px',
                backgroundColor: 'white',
                cursor: 'pointer'
              }}
            >
              <option value="atendente">Atendente</option>
              <option value="supervisor">Supervisor</option>
              <option value="admin">Administrador</option>
            </select>
          </div>

          {/* Status */}
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <label htmlFor="status" style={{
              fontWeight: '600',
              marginBottom: '8px',
              color: '#333',
              fontSize: '14px'
            }}>
              Status Inicial
            </label>
            <select
              id="status"
              name="status"
              value={formData.status}
              onChange={handleChange}
              disabled={saving}
              style={{
                padding: '12px 15px',
                border: '1px solid #dee2e6',
                borderRadius: '8px',
                fontSize: '14px',
                backgroundColor: 'white',
                cursor: 'pointer'
              }}
            >
              <option value="offline">Offline</option>
              <option value="online">Online</option>
              <option value="busy">Em atendimento</option>
            </select>
          </div>
        </div>

        {/* Botões de ação */}
        <div style={{
          display: 'flex',
          justifyContent: 'flex-end',
          gap: '15px',
          marginTop: '30px',
          paddingTop: '25px',
          borderTop: '1px solid #dee2e6'
        }}>
          <button
            type="button"
            onClick={() => navigate("/operadores")}
            disabled={saving}
            style={{
              background: '#6c757d',
              color: 'white',
              padding: '12px 28px',
              border: 'none',
              borderRadius: '8px',
              cursor: saving ? 'not-allowed' : 'pointer',
              fontWeight: '600',
              fontSize: '15px',
              minWidth: '120px',
              opacity: saving ? 0.7 : 1
            }}
          >
            Cancelar
          </button>
          
          <button
            type="submit"
            disabled={saving}
            style={{
              background: saving ? '#ccc' : '#e36a8d',
              color: 'white',
              padding: '12px 28px',
              border: 'none',
              borderRadius: '8px',
              cursor: saving ? 'not-allowed' : 'pointer',
              fontWeight: '600',
              fontSize: '15px',
              minWidth: '120px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '8px',
              opacity: saving ? 0.7 : 1
            }}
          >
            {saving ? (
              <>
                <span style={{
                  display: 'inline-block',
                  width: '16px',
                  height: '16px',
                  border: '2px solid #ffffff',
                  borderTop: '2px solid transparent',
                  borderRadius: '50%',
                  animation: 'spin 0.6s linear infinite'
                }}></span>
                Salvando...
              </>
            ) : isNew ? 'Criar Atendente' : 'Atualizar Atendente'}
          </button>
        </div>
      </form>
    </div>
  );
} 